/* 节日类型 */
export const nav = [
  {
    val: "国内节日",
    color: "rgba(233, 73, 87,0.85)",
    hoverColor: 'rgba(233, 73, 87,0.05)',
    type: 1,
    statType:2,
    checked: true
  },
  {
    val: "国际节日",
    color: "rgba(0, 167, 227,0.85)",
    hoverColor: 'rgba(0, 167, 227,0.05)',
    type: 2,
    statType:3,
    checked: true
  },
  {
    val: "24节气",
    color: "rgba(0, 170, 116,0.85)",
    hoverColor: 'rgba(0, 170, 116,0.05)',
    type: 3,
    statType:4,
    checked: true
  },
  {
    val: "电商活动",
    // color: "rgba(231, 61, 120,0.85)",
    // hoverColor: 'rgba(231, 61, 120,0.05)',
    color: "#ED6C00",
    hoverColor: 'rgba(237, 108, 0,0.05)',
    type: 4,
    statType:5,
    checked: true
  },
  {
    val: "重要事件",
    // color: "rgba(214, 103, 147,0.85)",
    // hoverColor: 'rgba(214, 103, 147,0.05)',
    color: "#894999",
    hoverColor: 'rgba(137, 73, 153,0.05)',
    type: 5,
    statType:6,
    checked: true
  },
  {
    val: "自定义日程",
    // color: "rgba(214, 103, 147,0.85)",
    // hoverColor: 'rgba(214, 103, 147,0.05)',
    color: "#475BCB",
    hoverColor: 'rgba(71, 91, 203,0.05)',
    type: 6,
    statType: -1,
    checked: true
  },
  /**
   {
    val: "农历",
    color: "#F7B455",
    hoverColor: 'rgba(247, 180, 85,0.05)',
    type: 5,
    checked: true
  },
   {
    val: "电商活动",
    color: "#E73D78",
    hoverColor: 'rgba(231, 61, 120,0.05)',
    type: 6,
    checked: true
  },
   {
    val: "广告投放",
    color: "#ED6C00",
    hoverColor: 'rgba(237, 108, 0,0.05)',
    type: 7,
    checked: true
  },
   {
    val: "媒体活动",
    color: "#0D64B0",
    hoverColor: 'rgba(13, 100, 176,0.05)',
    type: 8,
    checked: true
  },
   {
    val: "品牌投放",
    color: "#894999",
    hoverColor: 'rgba(137, 73, 153,0.05)',
    type: 9,
    checked: true
  },
   {
    val: "展会活动",
    color: "#2A3F52",
    hoverColor: 'rgba(42, 63, 82,0.05)',
    type: 10,
    checked: true
  }
   **/
]

/* 日历数据格式 */
export const list = [
  {
    val: '1', // 日期
    txt: "初一",  // 中文日期
    isRest: true, // 是否休息
    actData: [    // 活动列表
      {
        type: 1,  // 活动类型
        txt: "国际节日",
      },
      {
        type: 2,  // 活动类型
        txt: "国际节日",
      },
      {
        type: 3,  // 活动类型
        txt: "国际节日",
      }
    ]
  },

  {
    val: '2', // 日期
    txt: "初一",  // 中文日期
    isRest: false, // 是否休息
    actData: [    // 活动列表
      {
        type: 2,  // 活动类型
        txt: "国际节日",
      }
    ]
  },
  {
    val: '3', // 日期
    txt: "初一",  // 中文日期
    isRest: true, // 是否休息
    actData: [    // 活动列表
      {
        type: 2,  // 活动类型
        txt: "国际节日",
      }
    ]
  }
]


export const HEADER = {
  title: '营销日历查询_热点营销日历_潮国创意',
  meta: [
    {
      hid: 'keywords',
      name: 'keywords',
      content: '营销日历,日历查询'
    },
    {
      hid: 'description',
      name: 'description',
      content: '潮国创意提供热点营销日历查询，关注每月热点节日，提早规划活动和相关策划。'
    }
  ]
}
